@if (0 === layerCount()) {
  <p class="text-center mt-2">
    Add a layer to see the feature grid
  </p>
} @else {
  <div class="layers-list-wrapper d-flex justify-content-between" #listwrapper>
    <div class="d-flex layers-list-outer">
      <div class="dataset-list" ngbDropdown container="body" placement="top-left">
        <button type="button" class="btn-datasetlist" title="dataset list" ngbDropdownToggle>
          <i class="far fa-bars"></i>
        </button>
        <div class="dropdown-menu view" ngbDropdownMenu>
          @for (layer of activeLayers(); track layer) {
            <div>
              <button type="button" class="btn layer-label text-start bg-transparent" (click)="displayInGrid(layer)"
                title="View {{ layer.name }} features in grid" ngbDropdownItem>
                @if (isLayerFiltered(layer)) {
                  <i class="fas fa-filter"></i>
                  } {{ layer.name }}
                </button>
              </div>
            }
          </div>
        </div>
        <div #layerslist class="layers-list">
          @for (layer of activeLayers(); track layer) {
            <span class="button-wrapper" [class.selected-btn-span]="selected(layer.uid)"
              >
              <button type="button" class="btn layer-label text-start bg-transparent" [class.off]="layer.isVisible === false"
                (click)="displayInGrid(layer)" title="View {{ layer.name }} features in grid">
                <span class="">@if (isLayerFiltered(layer)) {
                  <i class="fas fa-filter"></i>
                } {{ layer.name }}</span>
              </button>
            </span>
          }
        </div>
      </div>
      <div class="layers-list-buttons d-flex">
        <button type="button" (click)="scrollLeft();" title="scroll left"><i class="fas fa-chevron-left"></i></button>
        <button type="button" (click)="scrollRight();" title="scroll right"><i class="fas fa-chevron-right"></i></button>
        <button type="button" (click)="closeGrid()" title="close table"><i class="fas fa-times"></i></button>
      </div>
    </div>
    <div>
      @if (showGridComponent) {
        <ejs-grid #grid [dataSource]="data" [columns]="columns" [allowTextWrap]="true" [enableVirtualization]="true"
          [height]="310" [allowExcelExport]="true" [toolbar]="toolbarOptions" [showColumnChooser]="true" [allowSorting]="true"
          [pageSettings]="pageSettings" (dataBound)="dataBound()" (created)="gridCreated()"
          (toolbarClick)="toolbarClick($event)" (rowSelected)="rowSelected($event)" (rowDeselected)="rowDeSelected($event)"
          (load)="load($event)" (destroy)="onGridDestroy($event)">
        </ejs-grid>
      } @else {
        <p class="text-center mt-4">
          Select a layer to load data
        </p>
      }
    </div>
  }






